import React from "react";
import { useLocation } from "react-router-dom";
import { URLdecode } from "../../utils/url";
import { pointsConfig } from "../../pointsConfig";
import MilesPointsPointsSection from "./MilesPointsPointsSection";
import MilesPointsLeaderboardSection from "./MilesPointsLeaderboardSection";
import MilesPointsRewardsSection from "./MilesPointsRewardsSection";
import MilesPointsBadgesSection from "./MilesPointsBadgesSection";
import MilesPointsReferralsSection from "./MilesPointsReferralsSection";
import MilesPointsLogSection from "./MilesPointsLogSection";

function MilesPointsContent() {
  useLocation();
  const params = URLdecode();

  switch (params?.tab) {
    case pointsConfig.tabs.points.code:
      return <MilesPointsPointsSection />;
    case pointsConfig.tabs.leaderboard.code:
      return <MilesPointsLeaderboardSection />;
    case pointsConfig.tabs.rewards.code:
      return <MilesPointsRewardsSection />;
    case pointsConfig.tabs.badges.code:
      return <MilesPointsBadgesSection />;
    case pointsConfig.tabs.referrals.code:
      return <MilesPointsReferralsSection />;
    case pointsConfig.tabs.log.code:
      return <MilesPointsLogSection />;
    default:
      return <MilesPointsPointsSection />;
  }
}

export default MilesPointsContent;
